import Progress from 'redux-progress';

import {
  IS_ON_BEHALF_OF_EMAIL,
  IS_SITE_ON_CONCESSION,
  IS_SITE_APPLICABLE_FOR_CONCESSION,
  CHILDREN_OVERVIEWS,
  CMT_SELF_SERVE_LINK,
  TRACKED_ELSEWHERE,
  ARCHIVE_UNARCHIVE_ACCOUNT,
  RESET_ARCHIVE_UNARCHIVE_ACCOUNT,
  ACCOUNT_HISTORY,
  ACCOUNT_HISTORY_AS_PARTNER,
  PRICING_PLAN_OVERVIEW,
  CREDIT_CARD_UPDATABLE_ACCOUNTS,
  RENEWAL_TOTAL_FOR_DISPLAY,
  OVERVIEW_WITH_ORG_CHILDREN,
  IS_HOSTED_ACCOUNT_PROVISIONING,
  UPDATE_SID,
  IS_SUSPENDED,
  POST_CREDIT_CARD_DETAILS,
  CREATE_PERSISTED_LICENSE,
  CUSTOMER_ACCOUNT_OVERVIEWS,
  CANCEL_AUTO_RENEW,
  EDIT_LICENSE_NAME_INLINE,
  RESTORE_EDIT_LICENSE_NAME_INLINE,
  POST_CURRENCY_ON_RECONCILABLE_VALIDATION,
} from 'modules/mac/duck/actions/accountId/types';
import type { MACAccountIdAction, MACAccountIdState, OverviewWithOrgChildren } from '../models';

export const initialState = {
  childrenOverviews: Progress.none,
  isOnBehalfOfEmail: Progress.none,
  isSiteOnConcession: Progress.none,
  CMTSelfServeLink: Progress.none,
  isSiteApplicableForConcession: Progress.none,
  trackedElsewhere: Progress.none,
  isArchivedAccount: Progress.none,
  accountHistory: Progress.none,
  pricingPlanAccountOverview: Progress.none,
  renewalTotal: Progress.none,
  overviewWithOrgChildren: Progress.none,
  creditCardUpdatableAccounts: Progress.none,
  isSuspended: Progress.none,
  postedCreditCardDetails: Progress.none,
  customerAccountOverviews: Progress.none,
  cancelledAutoRenew: {},
  editedLicenseNameInline: Progress.none,
  currencyOnReconcilableValidation: Progress.none,
};

export default (
  state: MACAccountIdState = initialState,
  action: MACAccountIdAction,
): MACAccountIdState => {
  switch (action.type) {
    case TRACKED_ELSEWHERE:
      return {
        ...state,
        trackedElsewhere: { ...state.trackedElsewhere, [action.accountId]: action.progress },
      };
    case CHILDREN_OVERVIEWS:
      return {
        ...state,
        childrenOverviews: action.progress,
      };
    case OVERVIEW_WITH_ORG_CHILDREN:
      return {
        ...state,
        overviewWithOrgChildren: action.progress as Progress<OverviewWithOrgChildren>,
      };

    case CUSTOMER_ACCOUNT_OVERVIEWS:
      return {
        ...state,
        customerAccountOverviews: action.progress as Progress<OverviewWithOrgChildren>,
      };

    case IS_ON_BEHALF_OF_EMAIL:
      return {
        ...state,
        isOnBehalfOfEmail: action.progress,
      };
    case IS_SITE_ON_CONCESSION:
      return {
        ...state,
        isSiteOnConcession: { ...state.trackedElsewhere, [action.accountId]: action.progress },
      };
    case CMT_SELF_SERVE_LINK:
      return {
        ...state,
        CMTSelfServeLink: action.progress,
      };
    case IS_SITE_APPLICABLE_FOR_CONCESSION:
      return {
        ...state,
        isSiteApplicableForConcession: action.progress,
      };
    case ARCHIVE_UNARCHIVE_ACCOUNT:
      return {
        ...state,
        isArchivedAccount: action.progress,
      };
    case RESET_ARCHIVE_UNARCHIVE_ACCOUNT:
      return {
        ...state,
        isArchivedAccount: null,
      };
    case ACCOUNT_HISTORY:
      return {
        ...state,
        accountHistory: { ...state.accountHistory, [action.accountId]: action.progress },
      };
    case ACCOUNT_HISTORY_AS_PARTNER:
      return {
        ...state,
        accountHistoryAsPartner: {
          ...state.accountHistoryAsPartner,
          [action.accountId]: action.progress,
        },
      };
    case PRICING_PLAN_OVERVIEW:
      return {
        ...state,
        pricingPlanAccountOverview: {
          ...state.pricingPlanAccountOverview,
          [action.accountId]: action.progress,
        },
      };
    case CREDIT_CARD_UPDATABLE_ACCOUNTS:
      return {
        ...state,
        creditCardUpdatableAccounts: action.progress,
      };
    case RENEWAL_TOTAL_FOR_DISPLAY:
      return {
        ...state,
        renewalTotal: { ...state.renewalTotal, [action.accountId]: action.progress },
      };
    case IS_HOSTED_ACCOUNT_PROVISIONING:
      return {
        ...state,
        isHostedAccountProvisioning: {
          ...state.isHostedAccountProvisioning,
          [action.accountId]: action.progress,
        },
      };
    case UPDATE_SID:
      return {
        ...state,
        updateSid: action.progress,
      };
    case IS_SUSPENDED:
      return {
        ...state,
        isSuspended: action.progress,
      };
    case POST_CREDIT_CARD_DETAILS:
      return {
        ...state,
        postedCreditCardDetails: action.progress,
      };
    case CREATE_PERSISTED_LICENSE:
      return {
        ...state,
        createdPersistedLicense: action.progress,
      };
    case CANCEL_AUTO_RENEW:
      return {
        ...state,
        cancelledAutoRenew: { ...state.cancelledAutoRenew, [action.accountId]: action.progress },
      };
    case EDIT_LICENSE_NAME_INLINE:
      return {
        ...state,
        editedLicenseNameInline: action.progress,
      };
    case RESTORE_EDIT_LICENSE_NAME_INLINE:
      return {
        ...state,
        editedLicenseNameInline: Progress.none,
      };
    case POST_CURRENCY_ON_RECONCILABLE_VALIDATION:
      return {
        ...state,
        currencyOnReconcilableValidation: action.progress,
      };
    default:
      return state;
  }
};
